import { isEmpty, isNotDefined } from '@terros/common'

export const formatPreferenceValue = (value: unknown): string => {
  if (isNotDefined(value)) return 'Not set'
  if (typeof value === 'boolean') return value ? 'On' : 'Off'
  if (typeof value === 'number') return String(value)
  if (typeof value === 'string') return formatWords(value)
  if (Array.isArray(value)) return isEmpty(value) ? 'None' : value.map(formatPreferenceValue).join(', ')
  return 'Custom settings'
}

const formatWords = (value: string): string => {
  const words = value.replaceAll(/([a-z])([A-Z])/g, '$1 $2').replaceAll('_', ' ')
  return words.charAt(0).toUpperCase() + words.slice(1)
}
